import { AuthenticationContext, AdalConfig, adalFetch, withAdalLogin } from 'react-adal';

export const adalConfig: AdalConfig = {
    tenant: 'a783bf91-8218-4535-8b22-f98d48f46833',
    clientId: '536ec978-e3ff-4a6d-9d08-2469af4439b8',
    //redirectUri: 'https://operations.pumpchecker.com/',
    redirectUri: 'https://operations.pumpchecker.com/',
    endpoints: {
        api: 'https://operations.pumpchecker.com/api',
    },
    cacheLocation: 'localStorage'
};

export const authContext = new AuthenticationContext(adalConfig);

export const getToken = () => authContext.getCachedToken(adalConfig.clientId);

export const adalApiFetch = (fetch, url, options) =>
  adalFetch(authContext, adalConfig.endpoints.api, fetch, url, options);

export const withAdalLoginApi = withAdalLogin(authContext, adalConfig.endpoints.api);


// WEBPACK FOOTER //
// ./src/adalConfig.js